import { HelpCenter } from "../features/help";

export default function Help() {
  return <HelpCenter />;
}
